import { useEffect } from 'react';

const useGeolocationPermission = (setGeolocation, enabled = true) => {
  useEffect(() => {

    if (!enabled) {
      // Skip if not enabled
      return;
    }

    if (!navigator.permissions) {
      console.warn("Permissions API not supported");
      return;
    }

    let permissionStatus;

    navigator.permissions.query({ name: 'geolocation' }).then((status) => {
      permissionStatus = status;

      setGeolocation(status.state === 'granted');

      permissionStatus.onchange = () => {
        const granted = status.state === 'granted';
        setGeolocation(granted);
        console.log('Geolocation permission changed:', status.state);
      };
    });

    return () => {
      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, [setGeolocation]);
};

export default useGeolocationPermission;
